module.exports = __webpack_public_path__ + "static/img/main2_3.0de20d39.png";